import { createAsyncThunk } from "@reduxjs/toolkit";
import { alertError } from "shared/api/alertError";
import { personalCabinetAPI } from "../api/index";

interface PostApplicationPwdInsurance {
  distanceId: number | undefined;
}

export const postApplicationPwdInsurance = createAsyncThunk(
  "personalCabinet/postApplicationPwdInsurance",
  async (data: PostApplicationPwdInsurance, { rejectWithValue }) => {
    try {
      const newTab = window.open("about:blank", "_blank");
      const res = await personalCabinetAPI.postApplicationPwdWithInsurance(data);

      if (typeof res.data === 'string') {
        if (res.data.startsWith('http')) {
          if (newTab) {
            newTab.location.href = res.data;
          } else {
            window.open(res.data, "_blank")
          }
        } else if (!isNaN(Number(res.data))) {
          window.location.reload();
        }
      } else if (typeof res.data === 'number') {
        window.location.reload();
      } else if (!res.data) {
        window.location.reload();
      }

      return res.data;
    } catch (error: any) {
      if (error.response?.data?.title) {
        alertError(error.response.data.title);
      }
      return rejectWithValue(error.response?.data?.title || "Произошла ошибка");
    }
  }
);
